import React from "react";
import PageSeo from "@/components/site/PageSeo";
import { useSettings } from "@/contexts/SettingsContext";

const PrivacyPolicyPage = () => {
    const { pages = {}, settings } = useSettings() || {};
    const sections = pages.privacy_sections || [];
    const contactEmail = settings?.support_email || "info@servall.in";
    const contactPhone = settings?.support_phone || "+91 90050 09500";

    return (
        <section className="container-x py-10 max-w-3xl" data-testid="privacy-page">
            <PageSeo pageKey="privacy" />
            <span className="eyebrow">Legal</span>
            <h1 className="font-display font-bold text-3xl sm:text-4xl mt-3">Privacy Policy</h1>
            <p className="text-sm text-[#7a7a84] mt-2">Last updated: {pages.privacy_last_updated || "August 2026"}</p>

            <div className="mt-8 space-y-6 text-[#4a4a52] leading-relaxed text-sm">
                {sections.length > 0 ? sections.map((sec, i) => (
                    <div key={i}>
                        <h2 className="font-display font-bold text-xl text-[#0f0f12] mb-2">{sec.title}</h2>
                        <p>{sec.body?.replace("info@servall.in", contactEmail).replace("+91 90050 09500", contactPhone)}</p>
                    </div>
                )) : (
                    <p>Privacy policy content is being updated. Contact {contactEmail} for any privacy questions.</p>
                )}
            </div>
        </section>
    );
};

export default PrivacyPolicyPage;
